import { LessonType } from '../../redux/types/live.type';
import { ColumnPermissionMap } from '../Home/common';

/**
 *  版权所有 © 2026 东方闻道 All Rights Reserved
 *
 *  创建者: chen
 *  创建时间: 2026-06-26 15:39
 *  文件名: src/pages/Lesson/permission.ts
 *  功能描述:
 */
export const getColumnCreatePermissions = (columnId: string) => {
  try {
    const permissions = window.localStorage.getItem('permissions');
    const data = permissions ? (JSON.parse(permissions) as ColumnPermissionMap) : null;
    const permission = data?.[columnId];
    return permission?.createPermissions || [];
  } catch (error) {
    return [];
  }
};

export const hasCreateLessonPermission = (createPermissions: number[]) => {
  if (!createPermissions || createPermissions.length === 0) {
    return false;
  }

  return createPermissions.some((permission: number) =>
    [LessonType.Live, LessonType.Vod, LessonType.Material].includes(permission),
  );
};

// 是否具有栏目同步权限
export const hasColumnSyncPermission = (columnId: string) => {
  try {
    const permissions = window.localStorage.getItem('permissions');
    const data = permissions ? (JSON.parse(permissions) as ColumnPermissionMap) : null;
    const permission = data?.[columnId];
    if (!permission) {
      return false;
    }
    return (
      permission?.matchAll ||
      (permission?.schoolPeriods?.length > 0 &&
        permission?.syncGradeCodes?.length > 0 &&
        permission?.syncSubjectCodes?.length > 0)
    );
  } catch (error) {
    return [];
  }
};

// 是否具有课程栏目创建权限
export const hasColumnCreatePermission = (columnId: string) => {
  try {
    const permissions = getColumnCreatePermissions(columnId);
    return hasCreateLessonPermission(permissions);
  } catch (error) {
    return false;
  }
};
